export default __webpack_public_path__ + "static/media/mobx.35fb4573.svg";